//@flow
import Model from '../../Utils/Model/model';

export type MembershipPlanObject = {
  code:string,
  price:number,
  title:string,
  description:string,
  short_description:string,
  checkout_description:string,
  rebill_interval:string,
  rebill_frequency:number,
  free_shipping_threshold:number,
  credit_expire_frequency:?number,
  credit_expire_interval:?string,
  credit:number,
};

const HIDE_PLANS = [
  'free_mem_wellness',
];

export default class MembershipPlanModel extends Model<MembershipPlanObject> {
  getCode():string {
    return this.attributes.code;
  }

  getTitle():?string {
    return this.attributes.title;
  }

  getDescription():?string {
    return this.attributes.description;
  }

  getPrice():?number {
    return this.attributes.price;
  }

  getShortDescription():?string {
    return this.attributes.short_description;
  }

  getCheckoutDescription():?string {
    return this.attributes.checkout_description;
  }

  getFrequency():number {
    return this.attributes.rebill_frequency;
  }

  getInterval():string {
    return this.attributes.rebill_interval;
  }

  getFreeShippingThreshold():number {
    return this.attributes.free_shipping_threshold;
  }

  getStoreCreditExpiry():string {
    const freq = this.attributes.credit_expire_frequency || 0;
    const interval = this.attributes.credit_expire_interval || '';
    let expiry = '';

    if (freq > 0 && interval) {
      expiry = freq.toString() + ' ' + interval;
      if (freq != 1) {
        expiry += 's';
      }
    }

    return expiry;
  }

  getStoreCredit():number {
    return this.attributes.credit;
  }

  hideMembershipInfo():boolean {
    return HIDE_PLANS.includes(this.getCode());
  }

}
